// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import cn from 'classnames';
import { isFunction } from 'lodash';
import React, { useCallback } from 'react';
import CopyIcon from 'react-feather/dist/icons/copy';
import EditIcon from 'react-feather/dist/icons/edit';
import EmailIcon from 'react-feather/dist/icons/mail';
import MoreIcon from 'react-feather/dist/icons/more-vertical';
import PlusIcon from 'react-feather/dist/icons/plus';
import SearchIcon from 'react-feather/dist/icons/search';
import DeleteIcon from 'react-feather/dist/icons/trash-2';
import { toast } from 'react-toastify';
import Popup from 'reactjs-popup';
import arrow from '../icons/arrow.svg';
import styles from './Button.module.css';

const defaultContent = {
  default: 'Ok',
  arrow: <img src={arrow} alt="" />,
};

defaultContent['arrow-up'] = defaultContent.arrow;
defaultContent['arrow-down'] = defaultContent.arrow;
defaultContent['arrow-left'] = defaultContent.arrow;
defaultContent['arrow-right'] = defaultContent.arrow;

export function Button({
  type = 'default',
  busy = false,
  pulse = false,
  className = '',
  ...rest
}) {
  const { children, ...buttonProps } = rest;
  const classes = cn(
    styles[type],
    { [styles.pulse]: pulse || false },
    className,
  );

  return (
    <button className={classes} disabled={busy} {...buttonProps}>
      {children || defaultContent[type]}
      {busy && <span className={styles.loader}></span>}
    </button>
  );
}

export default Button;

export function AddButton(props) {
  return (
    <Button className={styles.addButton} type="circle" {...props}>
      <PlusIcon />
    </Button>
  );
}

export function EditButton(props) {
  return (
    <Button type="icon" {...props}>
      <EditIcon />
    </Button>
  );
}

export function DeleteButton(props) {
  return (
    <Button className={styles.deleteButton} type="circle" {...props}>
      <DeleteIcon />
    </Button>
  );
}

export function MoreButton(props) {
  return (
    <button className={styles.moreButton} {...props}>
      <MoreIcon />
    </button>
  );
}

export function SearchButton(props) {
  return (
    <Button type="icon" {...props}>
      <SearchIcon />
    </Button>
  );
}

type MoreActionsButtonAction = {
  name: string;
  onClick?: () => void;
  enabled?: boolean | (() => boolean);
  visible?: boolean | (() => boolean);
  render?: (helpers: {
    close: () => void;
    hide: () => void;
  }) => React.ReactNode;
};

export class MoreActionsButton extends React.Component<{
  actions: MoreActionsButtonAction[];
}> {
  state = {
    hidden: false,
  };

  hide = () => {
    this.setState({ hidden: true });
  };

  render = () => {
    const { actions = [] } = this.props;
    const { hidden } = this.state;
    const contentStyle = hidden ? { opacity: '0' } : null;

    return (
      <Popup
        trigger={
          <span>
            <MoreButton />
          </span>
        }
        position="left top"
        arrow={false}
        contentStyle={contentStyle}
        offsetX={-1}
        onClose={() => this.setState({ hidden: false })}
      >
        {(close) => (
          <ul className="popup-menu">
            {actions.map((action, index) => {
              const isEnabled =
                action.enabled === undefined ||
                (isFunction(action.enabled)
                  ? action.enabled()
                  : action.enabled);
              const isVisible =
                action.visible === undefined ||
                (isFunction(action.visible)
                  ? action.visible()
                  : action.visible);
              return (
                isVisible && (
                  <li
                    className={isEnabled ? 'enabled' : 'disabled'}
                    key={index}
                    onClick={() => {
                      if (isEnabled && action.onClick) {
                        close();
                        action.onClick();
                      }
                    }}
                  >
                    {action.render
                      ? action.render({ close, hide: this.hide })
                      : action.name}
                  </li>
                )
              );
            })}
          </ul>
        )}
      </Popup>
    );
  };
}

export function CopyButton({ value, children, copiedMessage, tooltip }) {
  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.navigator?.clipboard.writeText(value || '');
      toast.info(copiedMessage || 'Copied to clipboard');
    },
    [copiedMessage, value],
  );

  return (
    <span
      title={tooltip || 'Copy'}
      className={styles.utilButton}
      onClick={onClick}
    >
      {children || <CopyIcon />}
    </span>
  );
}

export function EmailButton({ body, subject, email, tooltip }) {
  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      const params = new URLSearchParams({
        subject,
        body,
      })
        .toString()
        .replaceAll('+', '%20');

      document.location.href = `mailto:${email}?${params}`;
    },
    [body, subject, email],
  );

  return (
    <span
      title={tooltip || 'Email'}
      className={styles.utilButton}
      onClick={onClick}
    >
      <EmailIcon />
    </span>
  );
}
